import { getAuth } from "firebase/auth";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
} from "react-router-dom";
import { cancelLease } from "~/services/server";
import { sendAdvanceLeaseIntent } from "~/services/lease/advanceLeaseIntent";
import { _ObjectType } from "~/types";
import {
  _AdvanceLeaseActionType,
  _CancelLeaseActionType,
  AdvanceLeasePayload,
  CancelLeasePayload,
} from "~/types/lease";
import { INTENTS } from "~/utils";
import { S3ServiceLambda } from "~/services/s3";
import { FileModalContentLoaderType } from "~/components/FileModalView/FileModalView";

// TODO: Translate

export const LeaseDetailsDocsLoader = async ({
  request,
  params,
}: LoaderFunctionArgs): Promise<FileModalContentLoaderType | Response> => {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) redirect("/explore");

  const { searchParams } = new URL(request.url);
  const objectType = (searchParams.get("objectType") ||
    "application") as _ObjectType;
  const entityID = searchParams.get("entityID") || "";
  const disableActions = searchParams.get("disableActions") === "true";

  const files = await S3ServiceLambda.list({
    entityID,
    entityType: objectType,
  });

  return {
    files: files.data,
    objectType: objectType,
    entityID: entityID,
    disableActions: disableActions,
  };
};

export const LeaseDetailsDocsAction = async ({
  request,
  params,
}: ActionFunctionArgs) => {
  const formData = await request.formData();
  const intent = formData.get("intent");
  const leaseID = params.leaseID || "";

  switch (intent) {
    case INTENTS._advance_lease: {
      const payload = JSON.parse(
        formData.get("body") as string
      ) as AdvanceLeasePayload;

      return sendAdvanceLeaseIntent(leaseID, payload);
    }
    case INTENTS._cancel_lease_actions: {
      const payload = JSON.parse(
        formData.get("body") as string
      ) as CancelLeasePayload;

      const result = await cancelLease({ ...payload, leaseID });
      return result;
    }
    case INTENTS._delete_file: {
      const key: string = formData.get("body") as string;
      const result = await S3ServiceLambda.remove({ key });
      return result;
    }
  }
  return null;
};
